<template>
    <section>

<!--        <div>-->
<!--            <div class="sm:hidden">-->
<!--                <label for="tabs" class="sr-only">Select a tab</label>-->
<!--                <select id="tabs" name="tabs" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md">-->
<!--                    <option>Dares</option>-->
<!--                    <option>Wallet</option>-->
<!--                </select>-->
<!--            </div>-->
<!--            <div class="hidden sm:block">-->
<!--                <div class="border-b border-gray-200">-->
<!--                    <nav class="-mb-px flex" aria-label="Tabs">-->
<!--                        <a :href="route('notifications.index')" :class="{'border-indigo-500 text-indigo-600': route().current('notifications.index')}" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm">-->
<!--                            Posts-->
<!--                        </a>-->
<!--                        <a :href="route('notifications.wallet')" :class="{'border-indigo-500 text-indigo-600': route().current('notifications.wallet')}" class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 w-1/4 py-4 px-1 text-center border-b-2 font-medium text-sm">-->
<!--                            Wallet-->
<!--                        </a>-->
<!--                    </nav>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div v-if="hasNotifications" class="bg-white shadow-xl overflow-hidden sm:rounded-md">-->
<!--            <div>-->
<!--                <ul class="divide-y divide-gray-200">-->
<!--                    <li v-for="notification in notifications.data" class="py-6 px-8">-->
<!--                        <div class="flex space-x-3">-->
<!--                            <div class="flex-1 space-y-1">-->
<!--                                <div class="flex items-center justify-between">-->
<!--                                    <h3 :class="{'font-bold': !notification.read_at}" class="text-sm font-medium">{{ notification.data.title }}</h3>-->
        <!--                                    <p class="text-sm text-gray-500">{{ notification.createdAt | ago }}</p>-->
        <!--                                </div>-->
<!--                                <p v-if="notification.data.message" class="text-sm text-gray-500">{{ notification.data.message }}</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </li>-->
<!--                </ul>-->
<!--            </div>-->
<!--            <nav v-if="showNav" class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" aria-label="Pagination">-->
<!--                <div class="flex-1 flex justify-between sm:justify-end">-->
<!--                    <a v-if="notifications.prev_page_url" :href="notifications.prev_page_url" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">-->
<!--                        Previous-->
<!--                    </a>-->
<!--                    <a v-if="notifications.next_page_url" :href="notifications.next_page_url" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">-->
<!--                        Next-->
<!--                    </a>-->
<!--                </div>-->
<!--            </nav>-->
<!--        </div>-->

<!--        <jet-no-results v-if="!hasNotifications">-->
<!--                No Notifications-->
<!--            </jet-no-results>-->

    </section>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import JetTable from '@/Jetstream/Table';
import JetNoResults from '@/Jetstream/NoResults';
import Heading from '@/Components/Heading';

export default {

    name: 'Notifications',

    layout: AppLayout,

    props: ['notifications'],

    components: {
        Heading,
        JetNoResults,
        AppLayout,
        JetTable
    },

    computed: {
        hasNotifications(){
            if(!this.notifications) return false;
            return !!this.notifications.data;
        },

        showNav(){
            if(!this.notifications) return false;
            return this.notifications.next_page_url || this.notifications.prev_page_url;
        }

    }
}
</script>
